import axios from 'axios'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const SEGMENT_CREATE_URL = `${API_URL}api/v1/definition/segment/create`
export const SEGMENT_GET_ALL_URL = `${API_URL}api/v1/definition/segment/all`
export const SEGMENT_DELETE_URL = `${API_URL}api/v1/definition/segment/delete`
export const SEGMENT_UPDATE_URL = `${API_URL}api/v1/definition/segment/update`

export function createSegment(name: string) {
  return axios.post(SEGMENT_CREATE_URL, {name})
}

export function loadSegments(page = 0) {
  return axios.get(SEGMENT_GET_ALL_URL, {params: {page, size: 10}})
}

export function deleteSegment(segmentId: string) {
  return axios.post(SEGMENT_DELETE_URL + segmentId)
}

export function updateSegment(segmentId: string | null, name: string) {
  return axios.post(SEGMENT_UPDATE_URL + segmentId, {name})
}
